import * as React from "react";
import { withTranslation } from "react-i18next";
import FlexLayout from "../../../controls/FlexLayout";
import bbcode from "../../../controls/bbcode";
import { ComponentEx } from "../../../controls/ComponentEx";
class InfoPanel extends ComponentEx {
    mDefaultInfo;
    constructor(props) {
        super(props);
        this.mDefaultInfo =
            "Drag and drop your load order entries around to modify the order in which the game loads your mods.";
    }
    render() {
        const { t, info } = this.props;
        const Info = info;
        const panel = info === undefined ? (bbcode(t(this.mDefaultInfo))) : typeof info === "string" ? (bbcode(t(info))) : (React.createElement(Info, null));
        return (React.createElement("div", { id: "loadorderinfo" },
            React.createElement(FlexLayout, { type: "column" },
                React.createElement(FlexLayout.Flex, null,
                    React.createElement("h2", null, t("Changing your load order")),
                    panel),
                React.createElement(FlexLayout.Flex, null, this.renderErrorBox()))));
    }
    renderErrorBox() {
        const { t } = this.props;
        const { validationError } = this.props;
        const classname = validationError === undefined ? "valid" : "invalid";
        const title = t("Validation Error Console:");
        let errorText = t("No validation errors.");
        if (validationError !== undefined) {
            errorText = t(validationError.message + ":[br][/br]" + "{{invalid}}", {
                replace: {
                    invalid: validationError.validationResult.invalid
                        .map((invl) => `${invl.id} - ${invl.reason}`)
                        .join("[br][/br]"),
                },
            });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("h5", null, title),
            React.createElement("div", { className: classname, id: "fb-lo-errorbox" },
                React.createElement("p", null, bbcode(errorText)))));
    }
}
export default withTranslation(["common"])(InfoPanel);
